import { useQuery } from '@tanstack/react-query';
import { api } from '../../../global/adapters';
import { GetCompaniesBySearchParams } from '../../../global/adapters/crpAPI';
import { searchCompaniesKeys } from './queryKeys';

export const useSearchCompanies = (searchParams: GetCompaniesBySearchParams) => {
  const isSearchEntered = !!searchParams.identificationType && !!searchParams.identificationCode;

  return useQuery(
    searchCompaniesKeys.getCompaniesBySearchParams(searchParams),
    () => api.entities.getEntitiesBySearchParams(searchParams),

    {
      enabled: isSearchEntered,
    }
  );
};
